import styled from '@emotion/styled';
import { Button, Text } from '~/shared/components';

export const StyledReserveStockCountWrapper = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
});

export const StyledReserveStockCountText = styled(Text)(({ theme }) => ({
    fontWeight: theme.fontWeights.medium,
    minHeight: theme.fontSizes.sm,

    b: {
        fontWeight: theme.fontWeights.bold,
    },
}));

export const StyledReserveStockCountButton = styled(Button)(({ theme }) => ({
    fontWeight: theme.fontWeights.medium,
    paddingTop: 0,
}));
